//submitOnClick
$('body').on('click', 'a.submitOnClick', function () {
  $(this).parents('form').submit();
  return false;
});
